import { defineStore } from "pinia";
interface State {
  colors: string[];
}
export const useColorsStore = defineStore("colors", {
  state: (): State => ({
    colors: [],
  }),

  actions: {
    setColors(colors: string[]) {
      if (colors !== null && colors.length > 0) {
        this.colors.push(...colors);
      }
    },
  },
});
